import React from "react";
import "./Footer.css";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";

const Footer = () => {
  return (
    <footer className="footer">
      <h5>
        Made with
        <FavoriteRoundedIcon /> by Ashwin Gowda Magalu
      </h5>
    </footer>
  );
};

export default Footer;
